export const profile = {
  name: "Riya Gupta",
  role: "AI/ML Engineer",
  tagline:
    "Building agentic AI, RAG pipelines and deep learning systems that actually ship.",
  location: "Gurugram, Haryana — India",
  email: "riyagupta6011@gmail.com",
  phone: "+91 9810837205",
  github: "https://github.com/riyagupta1106",
  linkedin: "https://www.linkedin.com/in/riya-gupta-02b96b37a",
  resumeUrl: "/riya-gupta-resume.pdf",
  about: [
    "AI/ML enthusiast pursuing B.Tech in Computer Science Engineering with a specialization in Artificial Intelligence & Machine Learning.",
    "Comfortable applying deep learning and NLP techniques to real problems, and currently going deeper into Generative AI — building applications powered by LLMs, RAG pipelines, and agentic workflows.",
    "Balances a builder's instinct for shipping deployable, user-facing applications with strong DSA in C++. Actively looking to contribute as an AI/ML Engineer or Generative AI intern.",
  ],
  focus: ["Generative AI", "LLMs & RAG", "Deep Learning", "NLP", "Computer Vision"],
};

export const experience = [
  {
    role: "AI/ML Intern",
    company: "Neo Skillz",
    dates: "Jun 2026 — Present",
    location: "Remote",
    bullets: [
      "Working on AI/ML model development across GANs, DNNs and CNNs as part of a 6-month structured, mentor-led program.",
      "Building NLP-based intent classification pipelines for chatbot systems.",
      "Applying Python-based ML/DL libraries to build, train and evaluate models end-to-end.",
    ],
    stack: ["PyTorch", "TensorFlow", "NLP", "CNN", "GAN"],
  },
  {
    role: "GIS & Remote Sensing Intern",
    company: "ISA",
    dates: "Jan 2026 — Feb 2026",
    location: "Remote",
    bullets: [
      "Completed a winter training internship applying AI-driven techniques to geospatial and satellite data analysis.",
      "Delivered a structured project report assessed on data methodology, visualization and analytical interpretation.",
    ],
    stack: ["GIS", "Remote Sensing", "Python", "Geospatial ML"],
  },
  {
    role: "Web Developer Intern",
    company: "StandUp StartUps Pvt. Ltd.",
    dates: "Jun 2025 — Jul 2025",
    location: "Gurugram, Haryana",
    bullets: [
      "Built a responsive frontend (HTML, CSS, JavaScript) for a client website with SEO-friendly structure and cross-browser compatibility.",
      "Integrated PHPMailer for secure contact-form handling with validation and error handling.",
    ],
    stack: ["HTML", "CSS", "JavaScript", "PHPMailer", "SEO"],
  },
];

export const projects = [
  {
    name: "OmniMind AI",
    tagline: "Enterprise Multi-Agent AI Platform",
    description:
      "An AI assistant with a full RAG pipeline — document loading, embeddings, vector search and conversational memory using LangChain and ChromaDB. Modular FastAPI backend exposes chat, memory, history and document-based Q&A, with local LLM inference via Ollama for private, offline-capable responses.",
    stack: ["FastAPI", "LangChain", "Ollama", "ChromaDB", "Streamlit", "RAG"],
    href: "https://github.com/riyagupta1106/OmniMind-AI",
    featured: true,
    year: "2026",
  },
  {
    name: "ECG Arrhythmia Classification",
    tagline: "Hybrid CNN + Bi-LSTM Deep Learning",
    description:
      "Developed a hybrid CNN + Bidirectional LSTM model to classify ECG signals into arrhythmia categories, evaluated using accuracy, confusion matrix and ROC-AUC. Shipped a multi-page Streamlit app for interactive predictions and signal visualisation.",
    stack: ["Python", "CNN", "Bi-LSTM", "TensorFlow", "Streamlit"],
    href: "https://github.com/riyagupta1106/ecg-arrhythmia-system",
    featured: false,
    year: "2025",
  },
  {
    name: "Customer Churn Prediction",
    tagline: "Classification with threshold tuning",
    description:
      "Built a churn prediction model reaching 71% accuracy and 81% recall across 7K+ customer records. Tuned the classification threshold and applied precision-recall optimisation to reduce false negatives in high-risk customer detection.",
    stack: ["Python", "scikit-learn", "Logistic Regression", "Streamlit"],
    href: "https://github.com/riyagupta1106/Customer-Churn-Prediction-System",
    featured: false,
    year: "2026",
  },
  {
    name: "Customer Segmentation",
    tagline: "Unsupervised clustering & analytics",
    description:
      "Exploratory customer segmentation using unsupervised learning (K-Means and clustering analysis) on customer datasets. Built end-to-end in a Jupyter Notebook — data cleaning, feature scaling, cluster evaluation and visual profiling of each segment for actionable marketing insight.",
    stack: ["Python", "Jupyter", "K-Means", "Pandas", "Matplotlib"],
    href: "https://github.com/riyagupta1106/Customer-Segmentation",
    featured: false,
    year: "2026",
  },
  {
    name: "Packers",
    tagline: "PHP client website · full-stack",
    description:
      "A responsive client website for a packers & movers business built with PHP, HTML, CSS and JavaScript. Shipped alongside the StandUp StartUps internship — includes secure PHPMailer-powered contact form handling, form validation, error handling and SEO-friendly markup for better discoverability.",
    stack: ["PHP", "HTML", "CSS", "JavaScript", "PHPMailer"],
    href: "https://github.com/riyagupta1106/packers",
    featured: false,
    year: "2025",
  },
];

export const skills = {
  "AI / ML": [
    "Machine Learning",
    "Deep Learning",
    "Neural Networks",
    "NLP",
    "Computer Vision",
    "Generative AI",
    "LLMs",
    "RAG",
    "Prompt Engineering",
  ],
  Frameworks: [
    "LangChain",
    "TensorFlow",
    "scikit-learn",
    "FastAPI",
    "Streamlit",
    "OpenCV",
    "Ollama",
    "ChromaDB",
  ],
  Languages: ["Python", "C++", "C", "Java", "R", "SQL", "JavaScript", "HTML", "CSS"],
  Tools: [
    "Git / GitHub",
    "VS Code",
    "Jupyter",
    "MongoDB",
    "Power BI",
    "Pandas",
    "NumPy",
  ],
};

export const education = [
  {
    institution: "Dronacharya College of Engineering",
    location: "Gurugram, India",
    degree: "B.Tech, Computer Science & Engineering (AI & Machine Learning)",
    dates: "Aug 2023 — Jun 2027",
    detail: "CGPA: 8.5 / 10 · Latest semester: 9.1",
  },
];

export const certifications = [
  {
    name:"Introduction to Machine Learning",
    issuer:"NPTEL",
    year:"2025",
  },
  {
    name: "Pragati: Path to Future — Cohort 9",
    issuer: "Infosys Springboard",
    year: "2026",
  },
  {
    name: "Statistics for Data Science & Data Analysis with Python",
    issuer: "Infosys Springboard",
    year: "2026",
  },
  { name: "AI Dashboards using Microsoft Power BI", issuer: "Infosys Springboard" },
  { name: "Business Intelligence", issuer: "Infosys Springboard" },
  { name: "Programming in Java", issuer: "NPTEL" },
  { name: "Virtual Labs — CampusCrew Participation", issuer: "IIT Delhi", year: "2026" },
  { name: "Generative AI Tools", issuer: "Skill Nation" },
];

export const achievements = [
  "Reached the Semifinals of the Robotics e-Yantra Competition — IIT Bombay.",
  "Secured 3rd Position in 12th Grade academics.",
  "Balances internships, certifications and personal AI/ML projects while maintaining strong academic standing.",
];
